module.exports = __webpack_public_path__ + "img/bg-4.e749a16f.png";